import { TableCell, TableRow, IconButton, Tooltip, Box } from '@mui/material'
import { Delete as DeleteIcon, InsertDriveFile } from '@mui/icons-material'
import FilePreviewField from '../Fields/FilePreviewField'
import { Edit as EditNoteIcon } from '@mui/icons-material'
import { useAuthContext } from '../../../hooks/useAuthContext'
import moment from 'moment'

const PreviewRowWrapper = ({ note, deleteNotes, fileServices, setEditable, showActions }) => {
  const { user } = useAuthContext()

  return (
    <>
      <TableRow key={note.id}>
        <TableCell>{note.data_structure}</TableCell>
        <TableCell>{note.description}</TableCell>
        <TableCell>
          {note.data_structure === 'text' ? (
            note.content
          ) : (
            <Box
              sx={{
                padding: '6px 0px',
                display: 'flex',
                alignItems: 'center',
                gap: 0,
                width: 'fit-content',
              }}
            >
              <InsertDriveFile
                fontSize="small"
                sx={{ fontSize: 16, mr: -1.5, color: 'rgb(0 0 0 / 54%)' }}
              />

              <FilePreviewField
                id={'filePreview'}
                value={note.content}
                download={() => fileServices.downloadFile(user, note.content)}
                disabled={true}
              />
            </Box>
          )}
        </TableCell>

        <TableCell>
          {note.activity_template_name} (version {note.version})
        </TableCell>
        <TableCell>
          {note.name} ({note.email})<br />
        </TableCell>
        <TableCell>{moment(note.modified_at).format('DD MMM YYYY, HH:mm A')}</TableCell>

        {showActions && (
          <TableCell>
            {note.user_id == user.id && (
              <div style={{ display: 'flex', columnGap: 8 }}>
                <Tooltip title="Edit/additional-notes">
                  <IconButton size="small" onClick={() => setEditable(note.id)}>
                    <EditNoteIcon size="small" fontSize="14" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Delete/additional-notes">
                  <IconButton
                    size="small"
                    onClick={() => {
                      deleteNotes(note.id)
                    }}
                  >
                    <DeleteIcon size="small" fontSize="14" />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </TableCell>
        )}
      </TableRow>
    </>
  )
}

export default PreviewRowWrapper
